import { createEvent, createStore, forward, attach } from 'effector-root'
import { createFilter } from '@/pages/common/filter-dropdown/create-filter'
import { DropdownItem } from '@/pages/common/types'
import { getGroupsFiltersListFx } from '@/features/api/learning/courses/get-groups-filter-list'

export const groupDropdownModule = createFilter()

const getGroups = attach({
  effect: getGroupsFiltersListFx,
})

export const loadGroups = createEvent<void>()
export const $groups = createStore<DropdownItem[]>([])

forward({
  from: loadGroups,
  to: getGroups.prepend(() => ({})),
})

forward({
  from: getGroups.doneData.map((res) =>
    res.body.map((group) => {
      return {
        id: group.id,
        title: group.name,
        name: `${group.id}`,
        accept_dt_from: null,
        accept_dt_to: null,
      }
    })
  ),
  to: $groups,
})
